import * as React from 'react';
import { Container } from 'reactstrap';
import NavBar from "./menu/NavBar";
import Footer from './Footer';
import LoadingSplash from 'components/ui/LoadingSplash'
import { useBreakpoint } from 'hooks/useBreakpoint';

const GridlLineOverlay = (props: { gridSize: number }) => {
    const rows = Math.ceil(window.innerHeight / props.gridSize);
    const cols = Math.ceil(window.innerWidth / props.gridSize);

    return (
        <svg className="grid-line-overlay">
            {rows > 1 && [...Array(rows)].map((r, index) =>
                <rect key={index} x="0" width="100%" y={(index * props.gridSize) + "px"} height={((index + 1) * props.gridSize) + "px"} fill="none" />
            )}

            {cols > 1 && [...Array(cols)].map((c, index) =>
                <rect key={index} y="0" height="100%" x={(index * props.gridSize) + "px"} width={((index + 1) * props.gridSize) + "px"} fill="none" />
            )}
        </svg>
    )
};

export default (props: { children?: React.ReactNode }) => {
    const breakpoint = useBreakpoint();

    return (
        <div className={"layout " + breakpoint?.name + (breakpoint?.isDesktop ? " desktop" : "") + (breakpoint?.isTablet ? " tablet" : "") + (breakpoint?.isMobile ? " mobile" : "")}>
            <LoadingSplash />
            <NavBar />

            <Container className="main-container">
                {props.children}
            </Container>

            <Footer />
        </div>
    )
};
